/**
 * @generated SignedSource<<7a7dde2b709445dd8a7a6e7de02110c5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateBulkFixedPriceLockInput = {
  projectId?: string | null;
  locks?: ReadonlyArray<FixedPriceLockInputType | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type FixedPriceLockInputType = {
  startDate?: string | null;
  endDate?: string | null;
  amount?: number | null;
  timeAmount?: number | null;
  locked?: boolean | null;
  deliverableRevenues?: ReadonlyArray<DeliverableRevenueInputType | null> | null;
};
export type DeliverableRevenueInputType = {
  deliverableId?: number | null;
  revenue?: number | null;
};
export type createBulkFixedPriceLockMutation$variables = {
  input: CreateBulkFixedPriceLockInput;
};
export type createBulkFixedPriceLockMutation$data = {
  readonly createBulkFixedPriceLock: {
    readonly fixedPriceLocks: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly startDate: string | null;
        readonly endDate: string | null;
        readonly locked: boolean | null;
      } | null;
    } | null> | null;
  } | null;
};
export type createBulkFixedPriceLockMutation = {
  variables: createBulkFixedPriceLockMutation$variables;
  response: createBulkFixedPriceLockMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateBulkFixedPriceLockPayload",
    "kind": "LinkedField",
    "name": "createBulkFixedPriceLock",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectFixedPriceLockTypeEdge",
        "kind": "LinkedField",
        "name": "fixedPriceLocks",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectFixedPriceLockType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "locked",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createBulkFixedPriceLockMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createBulkFixedPriceLockMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "95e2917af90574394cd036eee3f36208",
    "id": null,
    "metadata": {},
    "name": "createBulkFixedPriceLockMutation",
    "operationKind": "mutation",
    "text": "mutation createBulkFixedPriceLockMutation(\n  $input: CreateBulkFixedPriceLockInput!\n) {\n  createBulkFixedPriceLock(input: $input) {\n    fixedPriceLocks {\n      node {\n        id\n        startDate\n        endDate\n        locked\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "78deccd41156af84559ef5f2e90ca88b";

export default node;
